// extracted by mini-css-extract-plugin
export default {"createpaper":"CreatePaper_createpaper__1Ja8l","cp-btn":"CreatePaper_cp-btn__6w1Iv","btn-sec":"CreatePaper_btn-sec__-pfww","btn":"CreatePaper_btn__rr7Rw"};